import { Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '@app/shared/auth/auth.service';
import { cognitoRedirectUrl } from '@app/shared/auth/auth.config';

@Injectable({
  providedIn: 'root',
})
export class HomePageGuard {
  constructor(private authService: AuthService) {}

  canActivate(): Observable<boolean | UrlTree> | boolean {
    if (!this.authService.isLoggedIn()) {
      window.location.href = cognitoRedirectUrl;
      return false;
    }

    if (this.authService.isSessionExpired()) {
      this.authService.refreshToken().subscribe({
        next: () => true,
      });
      return false;
    }

    return true;
  }
}
